<template>
  <div class="animated fadeIn">
    <b-container fluid>
      <div v-show="errorText !== ''" class="alert alert-danger" role="alert">
        {{errorText}}
      </div>
      <b-row>
        <b-col md="3">
          <b-form-group
            id="dateFilterFromGroup"
            label="Rango de fechas"
            description="Se filtrara los reportes por el rango de fechas seleccionado"
            label-for="filterRangeDate">
            <date-picker 
              v-on:contextmenu.native.stop.prevent 
              v-on:keydown.native.stop.prevent 
              id="filterRangeDate"
              name="filterRangeDate"
              ref="filterBeginDate"
              v-model="rangeDate" 
              format="YYYY-MM-DD"
              valueType="YYYY-MM-DD"
              :confirm="true"
              :lang="lang"
              confirm-text="Seleccione rango"  
              :clearable="true"
              range>
            </date-picker>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="4" v-if="isAdmin">
          <b-form-group label="Seller" class="mb-3">
            <b-form-select :options="organizations" v-model="account">
              <option slot="first" :value="null">Todos</option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-tabs b-model="tabIndex" class="mt-3">
            <b-tab title="Ventas" active>
              <sales-report :account="account" :rangeDate="rangeDate" @error="showError"></sales-report>
            </b-tab>
            <b-tab title="Estado de pedidos">
              <orders-report :account="account" :rangeDate="rangeDate" @error="showError"></orders-report>
            </b-tab>
            <b-tab title="Inventario de productos">
              <inventory-report :account="account" :rangeDate="rangeDate" @error="showError" @clear-filters="clearParentFilters"></inventory-report>
            </b-tab>
            <b-tab title="Catálogo de productos">
              <products-report :account="account" :rangeDate="rangeDate" @error="showError" @clear-filters="clearParentFilters"></products-report>
            </b-tab>
            <!-- <b-tab title="Liquidación de pedidos">
              <orders-report :account="account" :rangeDate="rangeDate" @error="showError" :liquidationReport="true"></orders-report>
            </b-tab> -->
          </b-tabs>
        </b-col>
      </b-row>
   </b-container>
  </div>
</template>

<script>

import OrdersReport from '@/components/reports/OrdersReport'
import ProductsReport from '@/components/reports/ProductsReport'
import InventoryReport from '@/components/reports/InventoryReport'
import SalesReport from '@/components/reports/SalesReport'
import 'vue2-datepicker/index.css'
import DatePicker from 'vue2-datepicker'

export default {
  name: 'reports-view',
  components: {
    OrdersReport,
    ProductsReport,
    InventoryReport,
    SalesReport,
    DatePicker
  },
  computed: {
    organizations () {
      return this.$store.getters.organizations
    }
  },
  methods: {
    tabChange () {
      this.errorText = ''
    },
    showError (errorText) {
      this.errorText = errorText
    },
    clearParentFilters () {
      this.rangeDate = null
      this.account = null
    }
  },
  data () {
    return {
      isAdmin: this.$store.getters.isAdmin,
      errorText: '',
      lang: {
        formatLocale: {
          // MMMM
          months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
          // MMM
          monthsShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
          // dddd
          weekdays: ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado'],
          // ddd
          weekdaysShort: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vier', 'Sab'],
          // dd
          weekdaysMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa']
        }
      },
      tabIndex: 0,
      rangeDate: null,
      account: null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/ReportsView.vue